import {
  put, takeEvery,
} from 'redux-saga/effects';
import { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import { select } from '~/_shared/utils/saga/effects';
import { dataLayersBTGsSelector } from '~/store/boundaryTerritoryGroups/dataLayersTool/dataLayersBTGs.selectors';
import { openMapTool } from '~/store/frontendState/leftSidebar/leftSidebar.actionCreators';
import { boundaryTerritoryGroupHighlightStarted } from './boundarySidebarState.actionCreators';

export function* boundarySidebarStateSagas() {
  yield takeEvery(boundaryTerritoryGroupHighlightStarted, onBoundaryInStatusBarClicked);
}

function* onBoundaryInStatusBarClicked(action: ReturnType<typeof boundaryTerritoryGroupHighlightStarted>) {
  const dataLayerBTGs: ReturnType<typeof dataLayersBTGsSelector> = yield select(dataLayersBTGsSelector);

  if (dataLayerBTGs.some(btg => btg.boundaryGroupId === action.payload.boundaryGroupId)) {
    // If the BTG's BG belongs to the Data Layers tool, we want to open that tool instead
    yield put(openMapTool(MapTool.DataLayers));
    return;
  }
  yield put(openMapTool(MapTool.Boundary));
}
